exports.debugOut = async (message, source, params) => {
  const {
    debug
  } = source;
  let out = '';
  if (debug !== undefined) {
    try {
      out += `${source.type}: "${debug}"\n`;
      if (message !== undefined) {
        out += `${message}\n`;
      }
      if (params !== undefined) {
        Object.keys(params).forEach(paramName => {
          const value = params[paramName];
          out += `${paramName} = ${JSON.stringify(value, null, 2)}\n`;
        });
      }
      /* eslint-disable no-console */
      console.log(out);
    } catch (_unused) {
      /* eslint-disable no-console */
      console.log(`debug statement failed, ignoring ${debug}`);
    }
  }
};